import controller from './smart-field.controller';
import template from './smart-field.html';

export default {
	template,
	bindings: {
		appendToBody:        '@?',
		disabled:            '<?ngDisabled',
		classHelper:         '&',
		ngModel:             '=',
		onCreate:            '&?',
		options:             '=?',
		order:               '@',
		placeholder:         '@?',
		qrcode:              '<?',
		smartFieldList:      '<?',
		smartFieldValidate:  '<?',
		smartFieldEvent:     '=?',
		tabindex:            '@?',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
		parent:      '^^?kform',
	},
};
